import { Empty, Spin } from "antd";
import { ResponsivePie } from "@nivo/pie";

function MyResponsivePie(props) {
  const {
    data = [],
    enableArcLinkLabels = false,
    legends = false,
    colorScheme = "nivo",
    isLoading = false,
  } = props;

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full" />;
  }

  if (!data.length)
    return (
      <div className="m-auto">
        <Empty description="No hay datos para mostrar." />
      </div>
    );

  return (
    <ResponsivePie
      data={data}
      margin={{ top: 20, right: 40, bottom: 40, left: 40 }}
      innerRadius={0.5}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      colors={{ scheme: colorScheme }}
      borderWidth={1}
      borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor="#fcfcfc"
      enableArcLinkLabels={enableArcLinkLabels}
      legends={
        legends && [
          {
            anchor: "bottom",
            direction: "row",
            justify: false,
            translateX: 0,
            translateY: 33,
            itemsSpacing: 0,
            itemWidth: 90,
            itemHeight: 14,
            itemTextColor: "#999",
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 15,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "#000",
                },
              },
            ],
          },
        ]
      }
    />
  );
}

export default MyResponsivePie;
